// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"style_breadcrumbs__mJxV6","current":"style_current__ksCNn","arrow":"style_arrow__RzOrt"};